import classNames from 'classnames';
import { Tooltip } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import { useFramework } from '@/framework';
import { useLocaleStore } from '@/i18n';
import { HIERARCHY_EVENTS } from '../../constants';
import './style.less';

type Props = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
};

export const Trigger: React.FC<Props> = ({ open, onOpenChange }) => {
    const { $t } = useLocaleStore();
    const framework = useFramework();

    const handleOpenChange = () => {
        const next = !open;

        onOpenChange(next);
        if (next) framework.events.emit(HIERARCHY_EVENTS.OPEN);
    };

    return (
        <Tooltip placement="top" title={$t((v) => v.plugin.hierarchy.layer)} trigger="hover">
            <span
                className={classNames('hierarchy-trigger', { 'hierarchy-trigger--active': open })}
                onClick={() => handleOpenChange()}
            >
                <IconFont name="LayerBold" fontSize={16} />
            </span>
        </Tooltip>
    );
};
